import React, { useState, useEffect, useRef } from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import API from "../api.js";
import { setAlert } from "action/index.js";
import { store, persistor } from "store/index";
import SimpleReactValidator from "simple-react-validator";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import { Navigate } from "react-router-dom";
import ReactPixel from "react-facebook-pixel";
import PhoneInputField from "components/Inputs/PhoneInputField";
import { isValidPhoneNumber } from "libphonenumber-js/mobile";

function Contact(props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [flag, setFlag] = useState(false);
  const [lockSubmit, setLockSubmit] = useState(false);
  const [isDialCodeSelected, setIsDialCodeSelected] = useState(null);
  const [, setRender] = useState(false);
  const forceUpdate = () => setRender((prev) => !prev);

  const validator = useRef(
    new SimpleReactValidator({
      messages: {
        alpha_space: "Allowed only letters and spaces.",
      },
      validators: {
        nameMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Name is required",
        },
        emailMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Email is required",
        },
        emailValid: {
          rule: (val) => {
            if (!val) return false;
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(val);
          },
          message: "Please enter a valid email address",
        },
        phoneMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Phone Number is required",
        },
        dialCodeRequired: {
          rule: () => false,
          message: "Please select a dial code",
        },
        phoneValid: {
          rule: (val) => {
            if (!val) return false;
            return isValidPhoneNumber(val);
          },
          required: true,
          message: "Please enter a valid phone number for the selected country",
        },
        commentMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Comment is required",
        },
      },
    })
  );

  useEffect(() => {
    if (isDialCodeSelected == false) {
      validator.current.showMessageFor("Enter Phone Number");
    }
  }, [isDialCodeSelected]);

  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);

    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "name") setName(value);
    if (name === "email") setEmail(value);
    if (name === "message") setMessage(value);
  };

  const handlePhoneChange = (value) => {
    setPhone(value);
  };

  const submitForm = () => {
    if (validator.current.allValid() && !lockSubmit) {
      setLockSubmit(true);

      const json = { name, email, phone, message };

      API({
        method: "POST",
        url: "post/contact",
        data: json,
      })
        .then((data) => {
          setSubmit(true);
          setLockSubmit(false);
          setName("");
          setEmail("");
          setPhone("");
          setMessage("");
          setFlag(true);

          store.dispatch(
            setAlert({
              flag: true,
              type: 1,
              message: data.data.response.message,
            })
          );
        })
        .catch(() => {
          setLockSubmit(false);
        });
    } else {
      validator.current.showMessages();
      forceUpdate();
    }
  };

  if (flag) {
    return <Navigate to="/thank-you" replace />;
  }

  return (
    <>
      <Helmet>
        <title>Contact LA Language Academy Australia for PTE, NAATI & IELTS Classes</title>
        <meta name="description" content="Get in touch with LA Language Academy for queries, consultation, or support regarding PTE, NAATI & IELTS courses in Australia. We're here to help you succeed!" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://www.languageacademy.com.au/contact`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta name="twitter:title" content="Contact LA Language Academy Australia for PTE, NAATI & IELTS Classes" />
        <meta name="twitter:description" content="Get in touch with LA Language Academy for queries, consultation, or support regarding PTE, NAATI & IELTS courses in Australia. We're here to help you succeed!" />
        <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta property="og:url" content={`https://www.languageacademy.com.au/contact`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Contact LA Language Academy Australia for PTE, NAATI & IELTS Classes" />
        <meta property="og:description" content="Get in touch with LA Language Academy for queries, consultation, or support regarding PTE, NAATI & IELTS courses in Australia. We're here to help you succeed!" />
        <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
      <div className="contact">
        <Header />
        <div className="form-page-wrapper mt-80">
          <div className="form-header">
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <div className="text-center">
                    <h2 className="primary-heading mfw-600">
                      Don’t be <br className="d-block d-md-none" />{" "}
                      <span className="wpl-badge pte-naati-badge text-white">
                        A Stranger
                      </span>
                    </h2>
                    <p className="sub-heading bold-sub-heading">
                      Feel free to contact us if you need some help,{" "}
                      <br className="d-none d-lg-block" />
                      consultation or you have some other questions.
                    </p>
                  </div>

                  <div className="form-content-outer position-relative">
                    <div className="form-content">
                      <div className="form-img">
                        <img
                          className="img-fluid"
                          src="/images/web-new-images/hero_img-02.png"
                          alt="LA"
                        />
                      </div>

                      <div className="form-content-right">
                        <div className="fieldOuter">
                          <h2 className="form-content-heading">
                            Fill in your details
                          </h2>
                        </div>

                        <div className="fieldOuter">
                          <label htmlFor="name">Name*</label>
                          <div className="form-input-outer">
                            <input
                              className="form-input"
                              id="name"
                              type="text"
                              name="name"
                              onChange={handleChange}
                              value={name}
                              placeholder="Enter Name"
                            />
                          </div>
                          {validator.current.message("Name", name, "nameMatch")}
                        </div>

                        <div className="fieldOuter">
                          <label htmlFor="email">Email*</label>
                          <div className="form-input-outer">
                            <input
                              className="form-input"
                              id="email"
                              type="email"
                              onChange={handleChange}
                              value={email}
                              name="email"
                              placeholder="Enter Email"
                            />
                          </div>
                          {validator.current.message(
                            "Email",
                            email,
                            "emailMatch|emailValid"
                          )}
                        </div>

                        <div className="fieldOuter">
                          <label htmlFor="phonenumber">Phone Number</label>

                          <PhoneInputField
                            id="phonenumber"
                            placeholder="Enter Phone Number"
                            value={phone}
                            changeEvent={handlePhoneChange}
                            onDialCodeStatusChange={(status) =>
                              setIsDialCodeSelected(status)
                            }
                          />

                          {phone === ""
                            ? validator.current.message(
                              "Enter Phone Number",
                              phone,
                              "phoneMatch"
                            )
                            : !isDialCodeSelected
                              ? validator.current.message(
                                "Enter Phone Number",
                                phone,
                                "dialCodeRequired"
                              )
                              : validator.current.message(
                                "Enter Phone Number",
                                phone,
                                "phoneValid"
                              )}
                        </div>

                        <div className="fieldOuter">
                          <label htmlFor="comments">Comments / Query</label>
                          <div className="form-input-outer">
                            <textarea
                              className="form-input"
                              id="comments"
                              onChange={handleChange}
                              name="message"
                              value={message}
                              placeholder="Enter your comments/Query"
                            ></textarea>
                          </div>
                          {validator.current.message(
                            "message",
                            message,
                            "commentMatch"
                          )}
                        </div>

                        <div className="fieldOuter m-0">
                          {!lockSubmit && (
                            <button
                              type="submit"
                              onClick={submitForm}
                              className="primary-btn"
                            >
                              SUBMIT DETAILS{" "}
                              <img
                                src="/images/web-new-images/right-arrow.svg"
                                alt="LA"
                              />
                            </button>
                          )}

                          {lockSubmit && (
                            <button type="submit" className="primary-btn">
                              Processing...
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="nal-info-section pb-0">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-xl-4 nal-info-content">
                <div className="nal-info-outer h-100">
                  <div className="nal-map h-100">
                    <iframe
                      className="h-100"
                      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3314.949239246!2d151.004612!3d-33.813623!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12a31ee6a6f49d%3A0x74dec1618ca5528d!2s46%20George%20St%2C%20Parramatta%20NSW%202150%2C%20Australia!5e0!3m2!1sen!2sin!4v1737116398848!5m2!1sen!2sin"
                    ></iframe>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-4 nal-info-content">
                <div className="nal-info-outer ask-us-wrapper">
                  <div className="nal-contact h-100">
                    <h2 className="secondary-heading text-start">
                      ASK US ANYTHING
                    </h2>
                    <a
                      href="https://goo.gl/maps/bhiU4au3764eDjVu8"
                      target="_blank"
                      className="nal-info-btn"
                    >
                      <img
                        className="phone-icon"
                        src="/images/web-new-images/icons/location-icon.svg"
                        alt="LA"
                      />
                      46 George Street, Parramatta
                    </a>
                    <a
                      href="mailto:info@languageacademy.com.au"
                      className="nal-info-btn"
                    >
                      <img
                        className="phone-icon"
                        src="/images/web-new-images/icons/mail-icon.svg"
                        alt="LA"
                      />{" "}
                      info@languageacademy.com.au
                    </a>
                    <a href="tel:426230061" className="nal-info-btn">
                      <img
                        className="phone-icon"
                        src="/images/web-new-images/icons/phone-arrow.svg"
                        alt="LA"
                      />{" "}
                      +61 426 230 061
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-4 nal-info-content">
                <div className="nal-info-outer ">
                  <div className="nal-contact nal-mobile-access h-100">
                    <h2 className="secondary-heading text-start text-white">
                      Easy Mobile Access
                    </h2>
                    <p className="normal-text text-white">
                      Let’s make your learning meaningful{" "}
                      <br className="d-none d-xl-block" /> and successful!
                    </p>
                    <div className="download-btns w-100 h-auto">
                      <a
                        target="_blank"
                        href="https://apps.apple.com/au/app/la-ccl/id1536541464"
                      >
                        <img
                          src="/images/web-new-images/app-store.svg"
                          alt="LA"
                        />
                      </a>
                      <a
                        target="_blank"
                        href="https://play.google.com/store/apps/details?id=com.languageacademy.naati&hl=en_AU&gl=US"
                      >
                        <img
                          src="/images/web-new-images/google-play.svg"
                          alt="LA"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Contact;
